import { combineReducers } from 'redux';

import activityApi from './activity/api';
import authReducer from './auth/reducers';
import campaignReducer from './campaigns/reducers';
import customerAdvocacyReducer from './customerAdvocacy/reducers';
import customReducer from './customizations/reducers';
import languagesApi from './languages/api';
import layoutReducer from './layout/reducers';
import loyaltyReducer from './loyalty/reducers';
import rewardsReducer from './rewards/reducers';
import shareApi from './share/api';
import statsApi from './stats/api';
import tablesApi from './tables/api';
import taxReducer from './tax/reducers';

const rootReducer = combineReducers({
  layout: layoutReducer,
  auth: authReducer,
  customizations: customReducer,
  campaigns: campaignReducer,
  loyalty: loyaltyReducer,
  customerAdvocacy: customerAdvocacyReducer,
  rewards: rewardsReducer,
  tax: taxReducer,

  [activityApi.reducerPath]: activityApi.reducer,
  [shareApi.reducerPath]: shareApi.reducer,
  [statsApi.reducerPath]: statsApi.reducer,
  [tablesApi.reducerPath]: tablesApi.reducer,
  [languagesApi.reducerPath]: languagesApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
